import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import OversizedFeeDetailsModalContent from './OversizedFeeDetailsModalContent';

const OversizedFeeDetailsModal = ({
    title,
    hideContentTitle,
    spot: {oversizedFeeMessage, vehicleRestriction},
    onHidden,
}) => {
    return (
        <Modal
            title={title}
            className="OversizedFeeDetailsModal"
            onHidden={onHidden}
        >
            <ModalContent>
                <OversizedFeeDetailsModalContent
                    oversizedFeeMessage={oversizedFeeMessage}
                    vehicleRestriction={vehicleRestriction}
                    hideTitle={hideContentTitle}
                />
            </ModalContent>
        </Modal>
    );
};

OversizedFeeDetailsModal.propTypes = {
    title: PropTypes.string,
    hideContentTitle: PropTypes.bool,
    spot: PropTypes.object,
    onHidden: PropTypes.func.isRequired,
};

export default OversizedFeeDetailsModal;
